module.exports = __webpack_public_path__ + "img/act-of-emotion-process-3-mobile.eda531fc.jpg";